import { ApplePayPaymentMethodUpdate } from '../..';

export class ApplePayPaymentMethodUpdateBuilder {
	private applePayPaymentMethodUpdate: ApplePayJSV14.ApplePayPaymentMethodUpdate;

	constructor() {
		this.applePayPaymentMethodUpdate = new ApplePayPaymentMethodUpdate();
	}

	setTotal(total: ApplePayJSV14.ApplePayLineItem): this {
		this.applePayPaymentMethodUpdate.newTotal = total;
		return this;
	}

	setNewLineItems(lineItems: ApplePayJSV14.ApplePayLineItem[]): this {
		this.applePayPaymentMethodUpdate.newLineItems = lineItems;
		return this;
	}

	setRecurringPaymentRequest(recurringPaymentRequest: ApplePayJSV14.ApplePayRecurringPaymentRequest): this {
		this.applePayPaymentMethodUpdate.newRecurringPaymentRequest = recurringPaymentRequest;
		return this;
	}

	getApplePayPaymentMethodUpdate(): ApplePayJSV14.ApplePayPaymentMethodUpdate {
		return this.applePayPaymentMethodUpdate;
	}
}
